import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

export const ProjectItemWrapper = styled(FlexRow)<{
  theme: { width?: string; backgroundColor?: string; marginBottom?: string };
}>`
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;
  gap: 12px;
  width: ${(props): string => (props.theme.width ? props.theme.width : '100%')};
  background-color: ${(props): string =>
    props.theme.backgroundColor ? props.theme.backgroundColor : 'unset'};
  height: 76px;
  border: 1px solid ${themeStyle.varInkLight};
  border-radius: ${themeStyle.radiusMedium};
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 12px;

  &:hover {
    box-shadow: ${themeStyle.varShadowSmallHeavy};
  }

  ${FlexRow} {
    min-width: 0;
    flex-grow: 1;
  }
`;

export const PreviewWrapper = styled.div`
  width: 60px;
  height: 60px;
  background-color: ${themeStyle.varInkLight};
  outline: 1px solid ${themeStyle.varInkSuperLight};
  border-radius: ${themeStyle.radiusSmall};
  margin-left: 8px;
`;

export const PreviewImage = styled.img`
  border-radius: ${themeStyle.radiusSmall};
  object-fit: cover;
  background-color: ${themeStyle.backgroundAltSolid};
`;
